<template>
  <div class="btn_con border_top1px">
    <!-- button -->
    <div
      v-if="!showLog"
      class="font12 font_weight500 line_height_17 colof buy_now"
      @click="modifyAddress"
    >
      修改地址
    </div>
    <div
      v-if="showLog"
      class="font12 font_weight500 line_height_17 colo087 look_log"
      @click="lookLogist"
    >
      查看物流
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showLog: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    modifyAddress() {
      this.$emit("modifyAddress", this.item.parcelId);
    },
    lookLogist() {
      this.$emit("lookLogist", this.item.trackingNo);
    }
  }
};
</script>
<style lang="less" scoped>
.btn_con {
  padding: 9px 12px 9px 0;
  display: flex;
  justify-content: flex-end;
  .buy_now {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    border-radius: 2px;
    padding: 7px 18px;
  }
  .look_log {
    padding: 7px 18px;
    border-radius: 2px;
    border: 1px solid #000;
  }
}
</style>
